var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66717 11C5.40212 10.9989 5.148 10.8973 4.95899 10.717L0.293338 6.18824C0.105517 6.00593 0 5.75867 0 5.50084C0 5.24302 0.105517 4.99576 0.293338 4.81345C0.481159 4.63114 0.735899 4.52872 1.00152 4.52872C1.26714 4.52872 1.52188 4.63114 1.7097 4.81345L5.66717 8.65477L14.2903 0.284728C14.3833 0.194458 14.4937 0.122852 14.6152 0.0739986C14.7367 0.0251448 14.867 0 14.9985 0C15.13 0 15.2602 0.0251448 15.3817 0.0739986C15.5033 0.122852 15.6137 0.194458 15.7067 0.284728C15.7997 0.374998 15.8734 0.482164 15.9238 0.600108C15.9741 0.718051 16 0.844462 16 0.972123C16 1.09978 15.9741 1.2262 15.9238 1.34414C15.8734 1.46208 15.7997 1.56925 15.7067 1.65952L6.37535 10.717C6.18634 10.8973 5.93222 10.9989 5.66717 11Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon02);
export default __webpack_public_path__ + "static/media/check_icon02.2f6c68f4d7e1da9efbf2cf0ec988e0f0.svg";
export { ForwardRef as ReactComponent };